import { render } from "./detail.vue?vue&type=template&id=03a2ddda"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=03a2ddda&lang=less"

import exportComponent from "D:\\公司项目\\jianlinchong\\MSG\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__